import type { Content } from "@prismicio/client";
import type { SliceComponentProps } from "@prismicio/react";

import UIKitContentBox, {
  type ContextBoxProps as UIKitContextBoxProps,
} from "@ui-kit/ContentBox";

import { SliceBox } from "@cms/components/SliceBox";

type ContentBoxProps = SliceComponentProps<Content.ContentBoxSlice>;

const getProps = (slice: ContentBoxProps["slice"]): UIKitContextBoxProps => {
  return {
    title: slice.primary.left_text || "",
    description: slice.primary.right_text || "",
    formattedDescription:
      slice.primary?.formatted_right_text?.length > 0
        ? slice.primary.formatted_right_text
        : undefined,
  };
};

const ContentBox = ({ slice, index }: ContentBoxProps): JSX.Element => {
  return (
    <SliceBox slice={slice} index={index}>
      <UIKitContentBox {...getProps(slice)} />
    </SliceBox>
  );
};

export default ContentBox;
